export const DASHBOARD_LOADING = 'FACILITY_DASHBOARD_LOADING';